import { Breadcrumbs, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { Download } from "lucide-react";
import { Admin_Parivartan_Get_Roles } from "../../../constants";
import axios from "axios";
import RoleTableComponent from "./component/RoleTableComponent";
import AddNewRoleModal from "./component/AddNewRoleModal";

const RoleComponent = () => {
  const handleBack = () => {};

  const [roleList, setRoleList] = useState([]);
  const [addNewRoleModalOpen, setAddNewRoleModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchRoleData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Admin_Parivartan_Get_Roles}`);
      const role = response.data.data || [];
      setRoleList(role);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching role data:", error);
      return null; // Return null or empty array on error
    }
  };

  useEffect(() => {
    fetchRoleData();
  }, []);

  const columns = [
    { headerName: "Role ID", field: "RoleId" },
    { headerName: "Role Name", field: "RoleName" },
  ];

  const fetchRoleDataExport = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_Roles}`);
      const region = response.data.data || [];

      return region;
    } catch (error) {
      console.error("Error fetching role data:", error);
      return null;
    }
  };

  const handleExport = async () => {
    const data = await fetchRoleDataExport();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];

          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Role_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `role_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Role Master
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Role Master</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddNewRoleModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New Role
            </Button>

            <Button
              onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <RoleTableComponent
          roleList={roleList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={fetchRoleData}
        />

        <AddNewRoleModal
          open={addNewRoleModalOpen}
          onClose={() => setAddNewRoleModalOpen(false)}
          onRefresh={fetchRoleData}
        />
      </div>
    </>
  );
};

export default RoleComponent;
